<shell-layout *ngIf="config" [error_identity]="true">
  <div class="product-card__all">
    <img class="m-auto img_gotoapp" [src]="config.imageUrl.url" [alt]="config.imageUrl.url" />

    <ui-text class="error__title" color="blue-500" size="h4" weight="semibold" align="center">
      {{ config.errorTitle }}
    </ui-text>

    <ui-text class="error__description" color="blue-300" align="center">
      <span [innerHTML]="config.errorDescription"></span>
    </ui-text>

    <div class="product-card__actions only-desktop">
      <a (click)="openQrModal(urlStore.APPLE_STORE)">
        <img src="assets/img/results/app_store_desktop.png" alt="App Store"
      /></a>
      <a (click)="openQrModal(urlStore.GOOGLE_PLAY)">
        <img src="assets/img/results/google_play_desktop.png" alt="Google play"
      /></a>
      <a (click)="openQrModal(urlStore.HUAWEI_STORE)">
        <img src="assets/img/results/app_gallery_desktop.png" alt="App Gallery"
      /></a>
    </div>

    <div class="product-card__actions only-mobile">
      <a href="https://apps.apple.com/us/app/id1476717951" target="_blank">
        <img src="assets/img/results/app_store_desktop.png" alt="App Store"
      /></a>
      <a href="https://play.google.com/store/apps/details?id=pe.pichincha.bm" target="_blank">
        <img src="assets/img/results/google_play_desktop.png" alt="Google play"
      /></a>
      <a href="https://appgallery.huawei.com/app/C107405799" target="_blank">
        <img src="assets/img/results/app_gallery_desktop.png" alt="App Gallery"
      /></a>
    </div>
  </div>
</shell-layout>
